import React from 'react';
import DrawCountdown from './DrawCountdown';

export default function DrawCountdownHero({ nextLottoTimestamp, onSearchHints }) {
  if (!nextLottoTimestamp) return null;

  return (
    <section className="draw-countdown-hero" aria-label="นับถอยหลังงวดหวย">
      <div className="draw-countdown-hero__content">
        <span className="draw-countdown-hero__badge">งวดนี้</span>
        <h2 className="draw-countdown-hero__title">เช็คเลขเด็ดก่อนออกรางวัล</h2>
        <DrawCountdown nextLottoTimestamp={nextLottoTimestamp} variant="hero" />
        <button type="button" className="draw-countdown-hero__cta" onClick={onSearchHints}>
          ดูเลขเด็ดงวดนี้ →
        </button>
      </div>
    </section>
  );
}
